angular.module('dnecom')
    .controller('emailTemplateWizardModalController', ["$scope", "$uibModalInstance", "template", function ($scope, $uibModalInstance, template) {
        $scope.template = angular.copy(template);

        $scope.$on('template.edit.done', function(updatedTemplate) {
            if (updatedTemplate) {
                $scope.template = updatedTemplate;
                $uibModalInstance.close();
            } else {
                $scope.close();
            }
        });

        $scope.close = function() {
            $uibModalInstance.dismiss('close');
        };
    }]);
